// Browser geolocation + key-less reverse geocoding.
//
// The header location pill uses this to (a) get the user's real coordinates and
// (b) turn them into a human city label ("Dallas, TX"). Reverse geocoding goes
// through BigDataCloud's free client-side endpoint, which needs no API key and
// is CORS-enabled, so it works straight from the browser. The resolved
// coordinates are also reused to anchor task store-search + Google Maps links.

export function getCurrentPositionAsync(
  options = { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 },
) {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation not supported'));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
      (err) => reject(err),
      options,
    );
  });
}

export async function reverseGeocode(lat, lng) {
  const url = `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${lat}&longitude=${lng}&localityLanguage=en`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`reverse geocode failed: ${res.status}`);
  const d = await res.json();

  const city = d.city || d.locality || d.principalSubdivision || '';
  const region = d.principalSubdivisionCode && d.principalSubdivisionCode.includes('-')
    ? d.principalSubdivisionCode.split('-')[1]
    : (d.principalSubdivision || '');
  const country = d.countryCode || '';
  const countryName = d.countryName || country;

  let label;
  if (city && country === 'US' && region) label = `${city}, ${region}`;
  else if (city) label = `${city}, ${countryName}`;
  else label = countryName || 'Current Location';

  return { city, region, country, countryName, label };
}
